<ng-container *ngIf="{
  row: columnData | async
} as $">
<span *ngIf="$.row ">{{getPaymentDetailsReport( $.row)}} </span>
</ng-container>
